import React from "react";
import styled from "styled-components";
import Header from '@/components/Header'
import  bwmodel from '@/config/bwmodel'

import { Toast} from 'antd-mobile'
import {  getObjectFormSerach } from '@/utils'
import bridge, { isiOS } from '@/config/JSbridge';
const isStorm = bwmodel.app === 'storm';

const ServiceCode = () => {
    const { id } = getObjectFormSerach(window.location.search);
    console.log(id);
    
    const handleSaveImg = () => {
   
      Toast.loading('正在保存...', 1.4)

      const img = new Image();
      img.crossOrigin = 'Anonymous'; // 如果是跨域图片，需要设置这个属性
      img.src = require('./img/image_24.png'); // 设置图片源地址
      img.onload = function() {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          const dataUrl = canvas.toDataURL('image/png'); // 可以改为image/jpeg根据需要
          
          bridge.callHandler('nativeEvent', {
            event: "saveImage",
            params: {
              imageData: dataUrl.replace('data:image/png;base64,', ''),
            }
          }, res => {
            Toast.hide()
            const result = JSON.parse(res);
            if (result.code === 0) {
              if (isiOS) {
                Toast.info('已保存到相册')
              }
          
              // Toast.info('已保存到相册')
            } else {
              Toast.info('保存失败')
            }
          })
          
      };
   
  }

  function  copyTextToClipboard() {
    // try {
    //    navigator.clipboard.writeText(id);
    //     // console.info('文本已复制到剪贴板');
    //     Toast.info('复制成功')
    // } catch (err) {
    //     console.error('复制失败', err);
    // }
     var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = id;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Toast.info('复制成功')
}
  const handleLeftClick = () => {
    
        bridge.callHandler('nativeEvent', {event: 'close', params: {
          isDelete: false
        }}, () => {})
      // }
    }
  return (
    <div>
      {
        isStorm && <Header
          title={'产业先声还原最真实的产业情报'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
        />
      }
    
      <ServiceCodeBox className="service-code-block"  style={{marginTop: isStorm?'44px':'0px'}}>
        <h1>恭喜您订阅成功</h1>
        <div data-v-04b7e8ac="" class="box">
         
         <div data-v-04b7e8ac="" class="code-box">
          <div data-v-04b7e8ac="" class="title"> 请添加助教领取课程及资料</div> 
          <div data-v-04b7e8ac="img-box">
          
            <img data-v-04b7e8ac="" src={require('./img/image_24.png')} alt=""></img>
          </div>
              
            
            {
              isStorm?  <div data-v-04b7e8ac="" class="tips">请截图/保存二维码，前往微信扫码添加客服</div>
              :<div data-v-04b7e8ac="" class="tips">长按二维码添加企微客服 咨询购买服务</div>
            }
            </div>
          </div>
          {
            isStorm && <button onClick={
              handleSaveImg
            }>  
            <img data-v-04b7e8ac="" src={require('./img/下载.png')} alt=""></img>
        保存二维码</button>
          
        }
 
  {
          id && <div class='tips2'> 订单号：{id} <span className="copy" onClick={()=>{
            copyTextToClipboard()
          }}>复制</span></div>
            
        }
      </ServiceCodeBox>
    </div>
  )
}

export default ServiceCode

export const ServiceCodeBox = styled.div`

  background-image: linear-gradient(180deg, #FFEFC2, #FFFFFF);
  
  backdrop-filter: blur(10px);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-height: 100vh;
  padding-top:64px;
  h1 {
    
    font-family: OPPO Sans 4.0, OPPO Sans 40;
    font-weight: bold;
    font-size: 22px;
    color: #262626;
    line-height: 32px;
    text-align: center;
    font-style: normal;
    text-transform: none
  }
  .code-box {
    text-align: center;
    margin: 0 20px;
    padding: 23px;
    background: red;
    background: linear-gradient( 180deg, #FFFEFD 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 20px 0px rgba(217,109,0,0.1);
    border-radius: 20px;
  }
  .title {
    font-size: 14px;
    color: #293241;
    }
  img {
    max-width: 100%;
  }
  .tips {
    margin-top: 0px;
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
  }
  button {
    width: 170px;
    height: 40px;
    background: #FFD745;
    border-radius: 20px;
    text-align: center;
    font-weight: 500;
    font-size: 15px;
    color: #333333;
    line-height: 21px;
    border: none;
    margin: 29px auto;
    display: block;
    img{
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
      margin-top: -4px;
      line-height: 21px;

    }
  }
     .copy {
        height: 22px;
        font-family: OPPO Sans 4.0, OPPO Sans 40;
        font-weight: 500;
        font-size: 16px;
        color: #621818;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: #FFF3E0;
        display: inline-block;
        padding: 0 10px;
        transform: scale(0.5);
      }
       .tips2 {
        color: #262626;
        text-align: center;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 13px;
        margin-top: 10px;
      }
}`


// WEBPACK FOOTER //
// ./src/views/activity_174/code.js